import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';
import ArticlesList from '../components/ArticlesList';
import { apiService, Article } from '../services/api';
import colors from '../theme/colors';

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2.5rem 2rem;
  background-color: ${colors.lightGray};
  min-height: calc(100vh - 200px);
`;

const BackLink = styled(Link)`
  color: ${colors.mainOrange};
  text-decoration: none;
  font-weight: 500;
`;

const Title = styled.h1`
  margin: 1rem 0 0.5rem;
  color: ${colors.mainBlack};
  font-size: clamp(1.5rem, 3vw, 2rem);
`;

const Subtext = styled.p`
  margin: 0 0 1rem 0;
  color: ${colors.textGray};
`;

const ErrorMessage = styled.div`
  color: ${colors.mainOrange};
  background-color: rgba(255, 86, 30, 0.08);
  border: 1px solid ${colors.mainOrange};
  border-radius: 8px;
  padding: 1rem;
`;

const Loading = styled.div`
  color: ${colors.textGray};
  padding: 1rem 0;
`;

const TagArticles: React.FC = () => {
  const { tag } = useParams<{ tag: string }>();
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const tagName = decodeURIComponent(tag || '').trim();

  useEffect(() => {
    const run = async () => {
      if (!tagName) {
        setArticles([]);
        setLoading(false);
        return;
      }
      setLoading(true);
      setError(null);
      try {
        const response = await apiService.getArticlesByTag(tagName);
        setArticles(Array.isArray(response.data) ? response.data : []);
      } catch (e: any) {
        setError(e?.message || 'Не вдалося завантажити статті за тегом');
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [tagName]);

  return (
    <PageContainer>
      <BackLink to="/">← На головну</BackLink>
      <Title>#{tagName || 'тег'}</Title>
      <Subtext>Усі статті з цим хештегом</Subtext>
      {loading ? (
        <Loading>Завантаження...</Loading>
      ) : error ? (
        <ErrorMessage>{error}</ErrorMessage>
      ) : (
        <ArticlesList articles={articles} />
      )}
    </PageContainer>
  );
};

export default TagArticles;
